// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__2RRm1","content":"styles_content__L8EWY","title":"styles_title__3XuaT","playlists":"styles_playlists__3ZKnW"};